import PresetInterface from "../../../interfaces/PresetInterface";
import GetItemsSum from "./GetItemsSum";
import GetItemsSale from "./GetItemsSale";

export default function (preset: PresetInterface, pretty = true): number|string {

    let val: number = 0

    if (preset.checkboxes.nds > 1) {
        const sum = <number>GetItemsSum(preset, false)
        const sale = <number>GetItemsSale(preset, false)

        if ([2, 3].indexOf(preset.checkboxes.nds) > -1) {
            val = (sum - sale) * 0.1
        } else if ([4, 5].indexOf(preset.checkboxes.nds) > -1) {
            val = (sum - sale) * 0.2
        } else if ([6, 7].indexOf(preset.checkboxes.nds) > -1) {
            val = (sum - sale) * 0.18
        }
    }


    if (pretty) {
        return val.toLocaleString('ru-RU')
    }
    return parseFloat(val.toFixed(2))
}